import { styled, Fab, Box } from '@mui/material'

export const FabWrapper = styled(Box)`
  position: fixed;
  bottom: 10px;
  right: 70px;
  transform: translateX(50%);
  z-index: 2299;

  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 12px;
`

export const FabSt = styled(Fab)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 35px;
    height: 40px;
    width: 40px;
    padding: 0;

    border-radius: 50%;

    line-height: 1.3;
    font-size: ${({ theme }) => theme.typography.pxToRem(10)};
    font-weight: 500;
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.background.default};

    & > svg {
      fill: ${({ theme }) => theme.palette.background.default};
    }
  }
`


